import RUF from "../../../util/redux";

export function downPaymentBankAccountsSave(state, action) {
  return RUF.updateObject(state, {
    model: RUF.updateObject(state.model, {
      downPayment: RUF.updateObject(state.model.downPayment, action.payload)
    })
  });
}
